import { render, staticRenderFns } from "./ProdDropDownBuilder.vue?vue&type=template&id=149c7db4"
import script from "./ProdDropDownBuilder.vue?vue&type=script&lang=js"
export * from "./ProdDropDownBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports